import axios from 'axios'
import { authZeroFetch, AxiosPut } from './AuthZeroFetch'

const GetUserInformation = () => {
    return authZeroFetch(axios.get, '/api/authentication/me')
}

const UpdateUserInfomation = (values) => {
    return authZeroFetch(AxiosPut, '/api/authentication/me', values)
}

const UpdateUserPremiumGoal = (values) => {
    return authZeroFetch(AxiosPut, '/api/authentication/me/goal/' + values)
}

const GetLinkForStripe = () => {
    return authZeroFetch(
        axios.get,
        '/api/authentication/portal?returnUrl=' + window.location.origin + '/account'
    )
}

export { GetUserInformation, UpdateUserInfomation, UpdateUserPremiumGoal, GetLinkForStripe }
